import { Pipe, PipeTransform } from "@angular/core";
import { ExportSimpleObject } from "./export.model";

@Pipe({ name: 'enumToArray', standalone: true })
export class EnumToArrayPipe implements PipeTransform {
    transform(sourceEnum: any): ExportSimpleObject[] {
        return Object.keys(sourceEnum).map((k, i) => { return { name: k, value: sourceEnum[k] } })
    }
}